<script>
import { TabItemsDirective, TabItemDirective } from "@syncfusion/ej2-vue-navigations/src/tab/items.directive";
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { controlStore, createStoreIndex, } from "@common/control/controlStore.js";
import { library } from "@common/library/library";
import moment from 'moment';
import { ddStore } from "@common/ddStore";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));

const editorSettings = {
    recordSource: {
        type: 'dropdown',
        label: 'Record Source',
        name: 'contextRecordType',
        items: [
            { text: 'RecordId Prop', value: 'recordId' },
            { text: 'Context Activity', value: 'aeId' }
        ]
    }
};

let profileConfig = {
    cId: "profile",
    cType: "profile",
    cTitle: "Profile",
    cTemplate: `<div :id="wrapperID" class="profile-wrapper" :class="{'is-from-popup': isFromPopup}">
                    <div v-if="!loading && !noTabsAvailable">
                        <div class="profile-title"><div class="profile-title-text">{{profileTitle}}</div></div>
                        <ejs-tab :id="cId" :selected="selectTab" :animation="animation" :selected-item="selectedTabIndex" :selecting="selectingTab" :created="tabCreated" :ref="cId" :enablePersistence="!isNew">
                            <div class="e-tab-header">
                                <div v-for="(tabItem, index) in tabs">
                                    <div>
                                        <span class="tab-list-title" :class="{'text-align-left':index === 0, 'text-align-right':index === lastTabIndex}">{{tabItem.title}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="e-content">
                                <div v-for="(tabItem, index) in tabs" v-bind:id="'profile_item_'+index" :key="index">
                                    <div v-show="selectedTabIndex === index">
                                        <div v-if="tabItem.COORD_PT_MAIN && !tabItem.loading">
                                            <component :is="tabItem.component"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ejs-tab>
                        <div class="profile-buttons">
                            <div class="profile-button" v-if="selectedTabIndex > 0"><control name="PREV"></control></div>
                            <div class="profile-button" v-if="selectedTabIndex < lastTabIndex"><control name="NEXT"></control></div>
                            <div class="profile-button"><control name="APPLY"></control></div>
                            <div class="profile-button"><control name="FINISH"></control></div>
                            <div class="profile-button"><control name="CANCEL"></control></div>
                        </div>
                    </div>
                </div>
               `,
    controls: [
        {
            id: "NEXT",
            name: "NEXT",
            type: "button",
            label: "Next",
            onclick: "next",
            width: "auto"
        },
        {
            id: "PREV",
            name: "PREV",
            type: "button",
            label: "Prev",
            onclick: "prev",
            width: "auto"
        },
        {
            id: "APPLY",
            name: "APPLY",
            type: "button",
            label: "Apply",
            onclick: "apply",
            width: "auto"
        },
        {
            id: "FINISH",
            name: "FINISH",
            type: "button",
            label: "Finish",
            onclick: "save",
            width: "auto"
        },
        {
            id: "CANCEL",
            name: "CANCEL",
            type: "button",
            label: "Cancel",
            onclick: "close",
            width: "auto"
        }
    ]
};

let profileCmp = {
    name: 'profile',
    editorSettings: editorSettings,
    props: {
        recordId: {
            default: false
        },
        recordPsp: {
            default: false
        },
        isFromPopup: {
            default: false
        },
        relatedRecords: {
            default: false
        }
    },
    data() {
        return {
            loading: true,
            tabsLoaded: false,
            noTabsAvailable: false,
            tabs: false,
            selectedTab: 0,
            lastTabIndex: 0,
            selectedTabIndex: 0,
            tabChecked: false,
            animation: {
                previous: {
                    effect: 'SlideLeftIn',
                    duration: 0,
                    easing: 'ease'
                },
                next: {
                    effect: 'SlideRightIn',
                    duration: 0,
                    easing: 'ease'
                }
            },
            profileInitialValues: {},
            recordTitle: '',
        };
    },
    computed: {
        isNew() {
            return this.computedRecordId <= 0;
        },
        wrapperID() {
            return this.cId + 'Wrapper';
        },
        profileTitle() {
            return this.computedRecordId > 0 ? 'Activity Profile: ' + this.recordTitle : 'New Activity Profile';
        },
        computedRecordId() {
            return this?.config?.recordSource
                ? this[this.config.recordSource] // eg: aeId
                : this.recordId;
        },
        computedPsp() {
            if (this.config?.recordSource && this.config.recordSource !== 'recordId') {
                return this.config.recordSource.replace('Id', ''); // volId or aeId becomes vol or ae
            }
            return this.recordPsp;
        }
    },
    watch: {
        computedRecordId() {
            this.initializeTab();
        }
    },
    methods: {
        onLoad() {
            this.initializeTab();
            this.$emit('update:profileLoaded', true);
        },
        resizeTabContent() {
            if (typeof this.$el.querySelectorAll !== 'function') return;
            let profileWrapper = this.$el.querySelectorAll('#' + this.wrapperID);
            let profileWrapperObj;
            if (profileWrapper && profileWrapper[0]) profileWrapperObj = profileWrapper[0];
            if (this.isFromPopup && profileWrapperObj) {
                profileWrapperObj = profileWrapperObj.closest('.e-dlg-content');
            }
            let profileHeader = this.$el.querySelectorAll('.e-tab-header');
            let profileTitle = this.$el.querySelectorAll('.profile-title-text');
            let profileContent = this.$el.querySelectorAll('.e-content');
            let profileButtons = this.$el.querySelectorAll('.profile-buttons');
            let profileWrapperHeight = 0;
            let profileHeaderHeight = 0;
            let profileButtonsHeight = 0;
            let profileTitleHeight = 0;
            if (profileWrapperObj) {
                profileWrapperHeight = profileWrapperObj.clientHeight;
            }
            if (profileTitle && profileTitle[0]) {
                profileTitleHeight = profileTitle[0].clientHeight || 40;
            }
            if (profileButtons && profileButtons[0]) {
                profileButtonsHeight = profileButtons[0].clientHeight + 20;
            }
            if (profileHeader && profileHeader[0]) {
                profileHeaderHeight = profileHeader[0].clientHeight + 20;
            }
            if (profileWrapperHeight && profileHeaderHeight && profileTitleHeight && profileContent && profileContent[0]) {
                profileContent[0].style.height = (profileWrapperHeight - profileHeaderHeight - profileButtonsHeight - profileTitleHeight) + 'px';
            }
        },
        async initializeTab() {
            if (this.computedRecordId && this.computedRecordId > 0) {
                let pathToRecord = 'recordStore.records.' + this.computedPsp + '.' + this.computedRecordId + '';
                this.$watch(pathToRecord, async function (newValue) {
                    this.updateControlValues();
                }, { deep: true });
            }
            window.addEventListener("resize", this.resizeTabContent);
            library.showLoadingIndicator(this.wrapperID);
            if (this.tabsLoaded) return;
            this.tabsLoaded = true;
            this.tabs = [];
            let tmpTabs = await configStore.getProfileTabs(this.computedPsp);
            if (tmpTabs.length) {
                this.tabs = library.cloneObj(tmpTabs);
                this.lastTabIndex = this.tabs.length - 1;
            } else {
                // no tabs available for current user
                this.noTabsAvailable = true;
                library.showDialog('There are no tabs to show. Please contact your administrator.', false, false, { showAsAlert: true });
                this.close();
            }
            this.loading = false;
            library.hideLoadingIndicator(this.wrapperID);
        },
        asyncLoadTabTemplate(tabID) {
            configStore.getProfileTabTemplate(this.computedPsp, tabID).then((tmpTabTemplate) => {
                if (tmpTabTemplate && tmpTabTemplate.COORD_PT_MAIN) {
                    for (let i in this.tabs) {
                        if (this.tabs[i].name !== tabID) continue;
                        this.parseTabTemplateInfo(this.tabs[i], tmpTabTemplate);
                    }
                }
            });
        },
        addTabControl(tmpControl) {
            tmpControl.type = tmpControl.INPUT_TYPE || tmpControl.SIMPLE_TYPE;
            if (tmpControl.type === 'logic') {
                tmpControl.hideLabel = true;
            }
            if (tmpControl.type === 'dropdown' && tmpControl.MULTI_VALUE) {
                tmpControl.type = 'multiselect';
            }
            if (tmpControl.type === 'jsonArray') {
                tmpControl.hideActions = true;
            }
            tmpControl.removeOnDestroy = true;
            tmpControl.label = tmpControl.label || (tmpControl.displayTitle && tmpControl.displayTitle.replace(this.computedPsp.toUpperCase() + '::', '')) || '';
            tmpControl.required = tmpControl.IS_REQUIRED;
            if (tmpControl.MAXVALUE && tmpControl.type === 'STRING') {
                tmpControl.htmlAttributes = { maxlength: tmpControl.MAXVALUE };
            }
            if (Array.isArray(tmpControl.LIST_VALUES)) {
                let tmpItems = [];
                for (let j in tmpControl.LIST_VALUES) {
                    tmpItems.push({
                        text: tmpControl.LIST_VALUES[j]['label'],
                        value: tmpControl.LIST_VALUES[j]['id']
                    });
                }
                tmpControl.fields = { text: 'text', value: 'value' };
                tmpControl.items = library.cloneObj(tmpItems);
            }
            tmpControl.ref = tmpControl.name + '_' + this.cId;
            let controlStoreIndex = createStoreIndex(this.storeId, tmpControl.name);
            if (typeof this.controlConfigs === 'undefined') this.controlConfigs = {};
            this.controlConfigs[tmpControl.name] = tmpControl;
            controlStore().addControl(tmpControl, this, controlStoreIndex);
        },
        async parseTabTemplateInfo(tab, info) {
            tab.COORD_PT_MAIN = info.COORD_PT_MAIN;
            if (typeof tab.component === 'undefined') {
                tab.component = this.getCustomTemplateComponent(tab.COORD_PT_MAIN);
            }
            if (info.PT_PROPERTY && info.PT_PROPERTY.USED_CONTROLS) {
                if (typeof tab.usedControls === 'undefined') tab.usedControls = [];
                if (typeof info.PT_PROPERTY.USED_CONTROLS === 'object' && !library.objIsEmpty(info.PT_PROPERTY.USED_CONTROLS)) {
                    for (let j in info.PT_PROPERTY.USED_CONTROLS) {
                        let tmpControlName = info.PT_PROPERTY.USED_CONTROLS[j].name.replace('_CtrlDrawAsLabel', '').replace('_CtrlDrawAsField', '');
                        if (info.PT_PROPERTY.USED_CONTROLS[j].name.indexOf('_CtrlDrawAsLabel') === -1) {
                            if (tab.usedControls.indexOf(tmpControlName) === -1) tab.usedControls.push(tmpControlName);
                        }
                        let tmpControl = library.cloneObj(info.PT_PROPERTY.USED_CONTROLS[j]);
                        if (!this.controlConfigs[tmpControl.name]) this.addTabControl(tmpControl);
                        if (tmpControl.name === 'AE_FOR_ORG_KIND') {
                            if (tab.usedControls.indexOf('AE_ONCE_PER_ASSIGNMENT') === -1) tab.usedControls.push('AE_ONCE_PER_ASSIGNMENT');
                            let tmpControl = {
                                name: 'AE_ONCE_PER_ASSIGNMENT',
                                INPUT_TYPE: 'hidden'
                            };
                            let aeOncePerassignment = Object.values(info.PT_PROPERTY.USED_CONTROLS).find((tmp) => tmp.name === 'AE_ONCE_PER_ASSIGNMENT');
                            if (aeOncePerassignment) tmpControl = library.cloneObj(aeOncePerassignment);
                            if (!this.controlConfigs['AE_ONCE_PER_ASSIGNMENT']) this.addTabControl(tmpControl);
                        }
                    }
                }
                if (this.computedRecordId && this.computedRecordId > 0 && tab.usedControls && tab.usedControls.length) {
                    let subscriptionParams = {
                        source: 'sds_getProfileField',
                        params: { recordId: this.computedRecordId, fields: tab.usedControls, params: { strictTypeResults: true } },
                        updateFrequency: 0,
                        doNotAddRecords: 1
                    };
                    let subscriptionDetail = this.recordStore.subscribe(subscriptionParams, this.cId, false, false, false, false, true);
                    let stopWatch = this.$watch('recordStore.subscriptions.' + subscriptionDetail.key + '.loading', (subscriptionLoading) => {
                        if (subscriptionLoading) {
                            library.showLoadingIndicator(this.wrapperID);
                        } else {
                            stopWatch();
                            this.updateControlValues();
                            library.hideLoadingIndicator(this.wrapperID);
                        }
                    }, { deep: true });
                }
            }
        },
        updateControlValues(tabId) {
            if (!this.computedRecordId || this.computedRecordId <= 0) return;
            let updateControls = [];
            for (let i in this.tabs) {
                if (typeof tabId !== 'undefined' && parseInt(tabId, 10) !== parseInt(i, 10)) continue;
                if (this.tabs[i] && Array.isArray(this.tabs[i].usedControls) && this.tabs[i].usedControls.length) {
                    updateControls = updateControls.concat(this.tabs[i].usedControls);
                }
            }
            for (let i in updateControls) {
                let tmpControlName = updateControls[i];
                if (!this.controls[tmpControlName]) continue;
                let tmpValue = library.cloneObj(this.recordStore.records['strict'][this.computedPsp][this.computedRecordId][tmpControlName]);
                if (tmpControlName === this.computedPsp.toUpperCase() + '_TITLE') this.recordTitle = tmpValue;
                if (tmpControlName === 'AE_ONCE_PER_ASSIGNMENT' && tmpValue === true) {
                    tmpControlName = 'AE_FOR_ORG_KIND';
                    tmpValue = -2;
                    delete this.profileInitialValues[tmpControlName];
                }
                if (this.profileInitialValues && typeof this.profileInitialValues[tmpControlName] === 'undefined' && tmpValue !== null) {
                    if (this.controlConfigs[tmpControlName].type === 'date' && tmpValue && !this.controlConfigs[tmpControlName].allowRelativeDate) {
                        tmpValue = moment(tmpValue).format('YYYY-MM-DD');
                    }
                    this.profileInitialValues[tmpControlName] = library.cloneObj(tmpValue);
                    this.controls[tmpControlName].value = tmpValue;
                    if (this.controlConfigs && this.controlConfigs[tmpControlName]) {
                        this.controlConfigs[tmpControlName].value = tmpValue;
                    }
                }
                if (tmpControlName === 'AE_PROFILE_TYPE') {
                    if (parseInt(this.computedRecordId, 10) > 0) {
                        this.sDs.post('sds_getProfileField', 'ae', this.computedRecordId, ['AE_WORKFLOW_TITLES']).then((response) => {
                            if (response.status === 'success' && response?.data?.[this.computedRecordId]['AE_WORKFLOW_TITLES']?.length) {
                                this.controls[tmpControlName].disabled = true;
                            }
                        });
                    }
                }
            }
            this.$nextTick(() => {
                this.resizeTabContent();
            });
        },
        async loadTabTemplate(tabID) {
            let tmpTabTemplate = await configStore.getProfileTabTemplate(this.computedPsp, tabID);
            if (tmpTabTemplate && tmpTabTemplate.COORD_PT_MAIN) {
                for (let i in this.tabs) {
                    if (this.tabs[i].name !== tabID) continue;
                    // eslint-disable-next-line no-await-in-loop
                    await this.parseTabTemplateInfo(this.tabs[i], tmpTabTemplate);
                }
            }
        },
        async selectTab(tmpEvent) {
            if (!this.tabs.length) return;
            if (tmpEvent && Number.isInteger(tmpEvent.selectedIndex)) {
                this.selectedTabIndex = tmpEvent.selectedIndex;
                if (typeof this.tabs[tmpEvent.selectedIndex] !== 'undefined' && typeof this.tabs[tmpEvent.selectedIndex].COORD_PT_MAIN === 'undefined') {
                    this.tabs[tmpEvent.selectedIndex].loading = true;
                    library.showLoadingIndicator('e-content-profile_' + tmpEvent.selectedIndex);
                    await this.loadTabTemplate(this.tabs[tmpEvent.selectedIndex]['name']);
                    this.tabs[tmpEvent.selectedIndex].loading = false;
                    library.hideLoadingIndicator('e-content-profile_' + tmpEvent.selectedIndex);
                } else if (typeof this.tabs?.[tmpEvent.selectedIndex]?.COORD_PT_MAIN !== 'undefined') {
                    this.updateControlValues();
                }
                this.tabs[tmpEvent.selectedIndex].opened = true;
            }
        },
        prev() {
            if (this.$refs && this.$refs[this.cId] && this.$refs[this.cId].ej2Instances && this.selectedTabIndex - 1 >= 0) {
                if (this.tabIsValid(this.selectedTabIndex)) {
                    this.$refs[this.cId].ej2Instances.select(this.selectedTabIndex - 1);
                }
            }
        },
        next() {
            if (this.$refs && this.$refs[this.cId] && this.$refs[this.cId].ej2Instances && this.selectedTabIndex + 1 <= this.$refs[this.cId].ej2Instances.lastIndex) {
                if (this.tabIsValid(this.selectedTabIndex)) {
                    this.$refs[this.cId].ej2Instances.select(this.selectedTabIndex + 1);
                }
            }
        },
        getChangedControls() {
            let controlsToSave = {};
            let controlsToSaveNames = [];
            for (let i in this.tabs) {
                if (this.tabs[i].opened && this.tabs[i].usedControls) {
                    for (let j in this.tabs[i].usedControls) {
                        let tmpControlName = this.tabs[i].usedControls[j];
                        if (tmpControlName === 'AE_ONCE_PER_ASSIGNMENT') continue;
                        if (
                            this.controls
                            && this.controls[tmpControlName]
                            // && !this.controls[tmpControlName].disabled
                        ) {
                            // save only changed values or all values if this is a new records
                            if (typeof this.profileInitialValues[tmpControlName] === 'undefined' || !library.isEqualObj(this.controls[tmpControlName].value, this.profileInitialValues[tmpControlName])) {
                                let changed = true;
                                if ((
                                    this.controls[tmpControlName].INPUT_TYPE === 'logic'
                                    && !this.profileInitialValues[tmpControlName]
                                    && !this.controls[tmpControlName].value
                                ) || (
                                    this.controls[tmpControlName].INPUT_TYPE === 'logic'
                                    && typeof this.profileInitialValues[tmpControlName] === 'undefined'
                                    && typeof this.controls[tmpControlName].value === 'object'
                                    && library.objIsEmpty(this.controls[tmpControlName].value)
                                ) || (
                                    this.controls[tmpControlName].INPUT_TYPE === 'number'
                                    && this.profileInitialValues[tmpControlName] === ''
                                    && this.controls[tmpControlName].value === null
                                ) || (
                                    (this.controls[tmpControlName].INPUT_TYPE === 'jsonArray' || this.controls[tmpControlName].INPUT_TYPE === 'grid')
                                    && typeof this.profileInitialValues[tmpControlName] === 'undefined'
                                    && this.controls[tmpControlName].value === ''
                                )) {
                                    changed = false;
                                }
                                if (changed) {
                                    controlsToSave[tmpControlName] = this.controls[tmpControlName].value;
                                    controlsToSaveNames.push(tmpControlName);
                                    if (tmpControlName === 'AE_FOR_ORG_KIND') {
                                        if (controlsToSave[tmpControlName] === -2) {
                                            controlsToSave[tmpControlName] = null;
                                            controlsToSave['AE_ONCE_PER_ASSIGNMENT'] = true;
                                        } else {
                                            controlsToSave['AE_ONCE_PER_ASSIGNMENT'] = null;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            let flattenControlsToSave = library.flatten(controlsToSave);
            // post NOTCHANGED value for not changed logic controls
            for (let i in flattenControlsToSave) {
                if (typeof flattenControlsToSave[i] === 'string' && flattenControlsToSave[i].indexOf('FilterEditor::FiltersColumns') !== -1) {
                    let initialValue = library.getByPath(this.profileInitialValues, i);
                    let currentValue = flattenControlsToSave[i];
                    if (initialValue !== currentValue && (initialValue || currentValue)) {
                        if (initialValue) {
                            try {
                                initialValue = library.parseLogicToBackend(library.parseLogicToFront(initialValue));
                            } catch (e) {
                                initialValue = false;
                            }
                        }
                        if (currentValue) {
                            try {
                                currentValue = JSON.parse(currentValue);
                            } catch (e) {
                                currentValue = false;
                            }
                        }
                    }
                    if (initialValue && currentValue && library.isEqualObj(initialValue, currentValue)) {
                        library.setByPath(controlsToSave, i, 'NOTCHANGED');
                    }
                }
            }
            for (let i in controlsToSave) {
                if (controlsToSave[i] === 'NOTCHANGED') delete controlsToSave[i];
            }
            return { controlsToSave, controlsToSaveNames };
        },
        async apply(isSave, fromConfirmPopUp) {
            isSave = isSave === true;
            fromConfirmPopUp = fromConfirmPopUp === true;
            if (this.profileIsValid()) {
                let response;
                let { controlsToSave, controlsToSaveNames } = this.getChangedControls();
                let recordId = this.computedRecordId;
                if (!fromConfirmPopUp && controlsToSave['AE_INCLUDED_LOGIC_FILTER_ID']) {
                    let dialogResponse = await library.showDialog('Volunteer/Activity affiliations may be added or deleted depending on these changes. Some of these changes may occur overnight.',
                        false,
                        () => {
                            this.controls['AE_INCLUDED_LOGIC_FILTER_ID'].value = this.profileInitialValues['AE_INCLUDED_LOGIC_FILTER_ID'];
                            if (this.controlConfigs && this.controlConfigs['AE_INCLUDED_LOGIC_FILTER_ID']) {
                                this.controlConfigs['AE_INCLUDED_LOGIC_FILTER_ID'].value = this.profileInitialValues['AE_INCLUDED_LOGIC_FILTER_ID'];
                            }
                        }, {
                            title: 'Warning',
                            okButtonLabel: 'Continue'
                        });
                    if (dialogResponse?.status === 'success') {
                        await this.apply(isSave, true);
                        return true;
                    }
                    return false;
                }
                library.showLoadingIndicator(this.wrapperID);
                if (!library.objIsEmpty(controlsToSave)) {
                    if (recordId && recordId > 0) {
                        response = await actionStore.updateProfileFields({ psp: this.computedPsp, recordId: recordId, fields: controlsToSave });
                    } else {
                        response = await sDs.post('er_create' + library.capitalizeFirstLetter(this.computedPsp), controlsToSave);
                        if (response && response.data && parseInt(response.data, 10) > 0) {
                            recordId = parseInt(response.data, 10);
                        }
                    }
                    library.hideLoadingIndicator(this.wrapperID);
                    if (!isSave) {
                        for (let i in controlsToSave) {
                            delete this.profileInitialValues[i];
                        }
                        let subscriptionParams = {
                            source: 'sds_getProfileField',
                            params: {
                                recordId: recordId,
                                fields: controlsToSaveNames,
                                params: { strictTypeResults: true }
                            },
                            updateFrequency: 0,
                            doNotAddRecords: 1
                        };
                        let subscriptionDetail = this.recordStore.subscribe(subscriptionParams, this.cId, true);
                        if (parseInt(this.computedRecordId, 10) === -1) {
                            let stopWatch = this.$watch('recordStore.subscriptions.' + subscriptionDetail.key + '.loading', (subscriptionLoading) => {
                                if (subscriptionLoading) {
                                    library.showLoadingIndicator(this.wrapperID);
                                } else {
                                    stopWatch();
                                    library.hideLoadingIndicator(this.wrapperID);
                                }
                            }, { deep: true });
                        }
                    }
                }
                library.hideLoadingIndicator(this.wrapperID);
                this.applyChangesToGrid();
                this.$emit('update:profileSaved', response);
                if (recordId !== this.computedRecordId) {
                    this.recordId = parseInt(response.data, 10);
                    this.$emit('update:recordId', parseInt(response.data, 10));
                }
            } else {
                return false;
            }
            return true;
        },
        applyChangesToGrid() {
            if (/Edit\d*Ae/g.test(window.name) || /New\d*Ae/g.test(window.name)) {
                if (window.opener && typeof window.opener.listEngineAction === 'function') {
                    window.opener.listEngineAction('find');
                }
            } else {
                if (/^System_/gi.test(window.name) && typeof listEngineAction === 'function') {
                    listEngineAction('find');
                }
            }
        },
        async save() {
            if (this.profileIsValid()) {
                let applyRes = await this.apply(true);
                if (applyRes) {
                    this.close();
                }
            }
        },
        close() {
            if (/Edit\d*Ae/g.test(window.name) || /New\d*Ae/g.test(window.name)) {
                window.close();
            } else {
                if (this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.componentDialogs && this.$parent.$parent.$parent.componentDialogs[0] && this.$parent.$parent.$parent.componentDialogs[0].cancelButton) {
                    this.$parent.$parent.$parent.componentDialogs[0].cancelButton.click();
                }
            }
        },
        tabIsValid(tmpTabID) {
            if (!this.tabs.length || !this.tabs[tmpTabID]) return true;
            let tabIsValid = true;
            let validationErrors = [];
            for (let i in this.tabs[tmpTabID].usedControls) {
                let tmpControlName = this.tabs[tmpTabID].usedControls[i];
                if (this.controls[tmpControlName]
                    && !this.controls[tmpControlName].hideControl
                    && !this.controls[tmpControlName].disabled
                    && typeof this.controls[tmpControlName].validationErrors === 'object'
                    && this.controls[tmpControlName].validationErrors.length) {
                    validationErrors = validationErrors.concat(this.controls[tmpControlName].validationErrors);
                    tabIsValid = false;
                }
            }
            if (!tabIsValid && validationErrors.length) {
                library.showDialog(validationErrors.join('<br/>'), false, false, { showAsAlert: true });
            }
            return tabIsValid;
        },
        profileIsValid() {
            for (let i in this.tabs) {
                if (this.tabs[i].opened && !this.tabIsValid(i)) {
                    return false;
                }
            }
            return true;
        },
        selectingTab(tmpEvent) {
            if (!this.tabs.length) return;
            if (tmpEvent.isSwiped) {
                tmpEvent.cancel = true;
                return;
            }
            tmpEvent.cancel = !this.tabIsValid(tmpEvent.selectedIndex);
        },
        async tabCreated() {
            if (this.tabs && this.tabs.length && this.$refs && this.$refs[this.cId] && typeof this.$refs[this.cId].ej2Instances !== 'undefined') {
                this.resizeTabContent();
                await this.selectTab({ selectedIndex: this.$refs[this.cId].ej2Instances.selectedItem });
                for (let i in this.tabs) {
                    if (
                        (this.tabs[i].opened || this.tabs[i].name === 'AE_MAIN')
                        && typeof this?.$refs?.[this.cId]?.ej2Instances?.selectedItem !== 'undefined'
                        && parseInt(i, 10) !== this.$refs[this.cId].ej2Instances.selectedItem
                    ) {
                        this.asyncLoadTabTemplate(this.tabs[i].name);
                    }
                }
            }
            // eslint-disable-next-line camelcase
            if ((/Edit\d*Ae/g.test(window.name) || /New\d*Ae/g.test(window.name)) && typeof lib_resizeToContent === 'function') {
                lib_resizeToContent(1);
            }
        },
        getCustomTemplateComponent(template) {
            let contextValues = {};
            let accordionSettings = { menuItems: [] };
            let contextPsps = ['vol', 'opp', 'org', 'lbe', 'sch', 'aff', 'ae'];
            for (let i in contextPsps) {
                let contextName = 'context' + library.capitalizeFirstLetter(contextPsps[i]) + 'Id';
                if (this[contextName]) {
                    contextValues[contextName] = this[contextName];
                }
                if (contextPsps[i] === this.computedPsp && this.computedRecordId > 0) {
                    contextValues[contextName] = this.computedRecordId;
                }
            }
            if (typeof template === 'string') template = template.replaceAll('c-id=', 'v-bind="contextValues" c-id=');
            let controls = this.controls;
            if (typeof template === 'string') {
                template = template.replaceAll('c-id=', 'v-bind="contextValues" c-id=');
                let domParser = new DOMParser();
                let templateDom = domParser.parseFromString(template, 'text/html');
                let accordionMenus = templateDom.querySelectorAll('accordion-menu');
                accordionMenus.forEach((accordionMenu) => {
                    let accordionMenuId = library.getUniqueID();
                    let slots = accordionMenu.querySelectorAll('slot');
                    slots.forEach((accordionSlot) => {
                        let accordionSlotId = library.getUniqueID();
                        let slotHeader = accordionSlot.getAttribute('header');
                        let slotTitle = accordionSlot.getAttribute('title');
                        accordionSettings.menuItems.push({
                            header: slotTitle ? (`<span title="${slotTitle}">${slotHeader}</span>`) : slotHeader,
                            useSlot: true,
                            slotName: accordionSlotId
                        });

                        accordionSlot.outerHTML = `<template v-slot:${accordionSlotId}>${accordionSlot.innerHTML}</template>`;
                    });
                    accordionMenu.outerHTML = `
                        <div v-if="isInitialAccordionMenu">
                            <div>
                                <accordion-menu unique-store-id="accordionMenu__${accordionMenuId}" c-id="accordionMenu__${accordionMenuId}" prop-control-configs="controls" prop-default-opened-item="0" :prop-i-config="accordionSettings" :use-parent-store-id="true">
                                ${accordionMenu.innerHTML}
                                </accordion-menu>
                            </div>
                        </div>
                    `;
                });

                template = templateDom.body.innerHTML.replaceAll('</st_control>', '');
                template = template.replace(/<st_control([^>]*)>/g, '<st_control$1 />');
            }

            return {
                template: '<div>' + template + '</div>',
                data() {
                    return {
                        contextValues: contextValues,
                        isInitialAccordionMenu: false,
                        accordionSettings
                    };
                },
                computed: {
                    controls() {
                        return controls;
                    }
                },
                created() {
                    // if the delay is less than 300 ms, the first slot that opens automatically may not display controls
                    setTimeout(() => {
                        this.isInitialAccordionMenu = true;
                    }, 500);
                },
                components: {
                    "accordion-menu": defineAsyncComponent(() => import('@common/accordionMenu/accordionMenu.vue')),
                    'control': defineAsyncComponent(() => import('@common/control/control.vue')),
                    'st_control': defineAsyncComponent(() => import('@common/control/control.vue'))
                }
            };
        },
        async controlChange(ev, ctrl) {
            if (ev && ev.e && typeof ctrl?.name !== 'undefined') {
                switch (ctrl.name) {
                    case 'AE_FOR_ORG_KIND':
                        this.controls['AE_ONCE_PER_ASSIGNMENT'].value = ev.value === -2;
                        if (this.controlConfigs && this.controlConfigs['AE_ONCE_PER_ASSIGNMENT']) {
                            this.controlConfigs['AE_ONCE_PER_ASSIGNMENT'].value = ev.value === -2;
                        }
                    // eslint-disable-next-line no-fallthrough
                    case 'AE_FOR_ORG_KIND_SECONDARY':
                        library.showLoadingIndicator('body');
                        // eslint-disable-next-line no-case-declarations
                        let response = await this.sDs.post('sds_getProfileField', 'ae', this.computedRecordId, ['AE_AFFILIATIONS_COUNT']);
                        // eslint-disable-next-line no-case-declarations
                        let aeAffiliationsCount = response?.status === 'success' ? response?.data?.[this.computedRecordId]?.['AE_AFFILIATIONS_COUNT'] || 0 : 0;
                        if (aeAffiliationsCount > 0) {
                            let message = await ddStore.getAlias('ACTIVITY_ENTITY', 'AEPROFILE_AE_FOR_ORG_KIND_CHANGE_CONFIRM', aeAffiliationsCount);
                            library.hideLoadingIndicator('body');
                            await library.showDialog(message, false, () => {
                                this.controls[ctrl.name].value = ev.previousItemData.value;
                                if (this.controlConfigs && this.controlConfigs[ctrl.name]) {
                                    this.controlConfigs[ctrl.name].value = ev.previousItemData.value;
                                }
                            }, {
                                okButtonLabel: 'Continue'
                            });
                        }
                        library.hideLoadingIndicator('body');
                        break;
                }
            }
            if (ev && ev.event && typeof ctrl?.name !== 'undefined') {
                switch (ctrl.name) {
                    case 'AE_ONCE_AND_DONE':
                        // eslint-disable-next-line no-case-declarations
                        let message = await ddStore.getAlias('ACTIVITY_ENTITY', this.controls['AE_ONCE_AND_DONE'].value ? 'AEPROFILE_AE_ONCE_AND_DONE_ON_CONFIRM' : 'AEPROFILE_AE_ONCE_AND_DONE_OFF_CONFIRM');
                        await library.showDialog(message, false, () => {
                            let prevValue = !this.controls['AE_ONCE_AND_DONE'].value;
                            this.controls['AE_ONCE_AND_DONE'].value = prevValue;
                            if (this.controlConfigs && this.controlConfigs['AE_FOR_ORG_KIND']) {
                                this.controlConfigs['AE_ONCE_AND_DONE'].value = prevValue;
                            }
                        }, {
                            okButtonLabel: 'Yes',
                            cancelButtonLabel: 'No'
                        });
                        break;
                }
            }
        }
    },
    components: {
        "ejs-tab": defineAsyncComponent(() => import('@common/syncfusion/tab')),
        "e-tabitems": TabItemsDirective,
        "e-tabitem": TabItemDirective
    }
};

componentStore.initComponent(profileCmp, profileConfig, '@common/profile.vue');
export { profileConfig, profileCmp };
export default profileCmp;
</script>

<style>
#dialog_container_openProfile, #dialog_container_openProfile > div {
    height: 100%;
}
</style>
<style scoped>
:deep(.profile-wrapper) {
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    padding: 0 15px;
}
:deep(.is-from-popup) {
    width: 100%;
    height: 100%;
}
:deep([id^="e-content-profile"]) {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 15px;
    /* min-height: 420px; */
    height: 100%;
    border: 1px solid #ccc;
    background-color: white !important;
    margin: 0 !important;
}
:deep(.e-tab-header) {
    margin-bottom: 10px;
}
:deep(.label-wrapper),
:deep(.e-control label) {
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 13px !important;
    font-weight: 600;
    margin: 0 10px 0 0;
}
:deep(.e-tab-header .e-item) {
    text-align: center;
    font-size: 13px !important;
    border-right-width: 0;
    border-left-width: 0;
    border-top-style: none;
    border-right-style: none;
    border-bottom: 2px solid #ccc !important;
    cursor: pointer !important;
    background: transparent !important;
}
:deep(.e-tab-header .e-item .tab-list-title) {
    color: rgb(48, 48, 48) !important;
    text-transform: none !important;
    font-weight: 400 !important;
}
:deep(.e-tab-header .e-item.e-active) {
    border-bottom: 2px solid #eb5202 !important;
    color: #303030 !important;
    font-weight: 600 !important;
    background: #fff !important;
}
:deep(.e-tab-header .e-item.e-active .tab-list-title) {
    font-weight: 600 !important;
}
:deep(.e-tab-header .e-indicator) {
    display: none !important;
}
:deep(.profile-buttons) {
    float: right;
    margin-top: 10px;
    margin-bottom: 10px;
    clear: both;
}
:deep(.profile-button) {
    display: inline-block;
    margin-left: 10px;
}
:deep(.profile-title) {
    color: #41362f!important;
    display: inline;
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    line-height: 2;
    min-height: 30px;
}
:deep(.control) {
    margin-top: 10px;
}
:deep(.sub-setting-array .sub-setting-items ul li + li) {
    border-top: 2px solid #d6d6d6;
}
:deep(.sub-setting-array .object-item-toggle) {
    background: #f9f9f9;
    color: black;
}
:deep(.sub-setting-array .object-item-header-even .object-item-toggle) {
    background: white;
}
:deep(.sub-setting-array .object-item-content) {
    padding: 8px;
    border: 1px solid #d6d6d6;
}
:deep(.profile-title-text) {
    width: 800px;
    word-break: break-word;
}
:deep(.e-tab-header .e-items) {
    padding: 0 !important;
}
:deep(.e-tab-header .e-scroll-nav) {
    display: none !important;
}
:deep(.e-toolbar .e-toolbar-item) {
    display: block !important;
    float: left !important;
}
</style>
